import { useNavigate } from 'react-router'
import { GoChevronRight, GoChevronLeft } from 'react-icons/go'
import { IoBrushOutline } from 'react-icons/io5'

const Accessibility: React.FC = () => {
  const navigate = useNavigate()
  return (
    <div className="flex w-full flex-col text-sm">
      <div className="flex h-[50px] items-center pl-[10px] text-xl font-semibold">
        <div className="flex items-center">
          <button
            type="button"
            className="hover-main mr-[10px] flex h-[30px] w-[30px] items-center justify-center rounded-full"
            onClick={() => {
              navigate('/settings')
            }}
          >
            <GoChevronLeft />
          </button>
          <h1>Accessibility, display and languages</h1>
        </div>
      </div>
      <div className="text-sub pt-[15px] pb-[25px] pl-[25px]">
        Manage how app content is displayed to you.
      </div>
      <button
        type="button"
        className={
          'hover-main flex h-[80px] w-full cursor-pointer items-center justify-between'
        }
        onClick={() => {
          navigate('../display')
        }}
      >
        <div className="flex items-center justify-between">
          <IoBrushOutline className="text-sub mr-[30px] ml-[30px] text-lg" />
          <div className="flex w-auto flex-col text-wrap">
            <h1 className="flex items-center">Display</h1>
            <h1 className="text-sub flex items-center">
              Manage your theme display.
            </h1>
          </div>
        </div>
        <div className="text-sub flex h-full w-auto items-center pr-[15px] text-2xl">
          <GoChevronRight />
        </div>
      </button>
    </div>
  )
}

export default Accessibility
